module.exports = __webpack_public_path__ + "static/media/IndustryLeader007.790d7e15.png";